import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth'

// Initialize Firebase
var config = {
  apiKey: "AIzaSyDakDygIGTVzMkPQSJzeSB1ntAaivh4sT4",
  authDomain: "react-redux-app-4ed99.firebaseapp.com",
  databaseURL: "https://react-redux-app-4ed99.firebaseio.com",
  projectId: "react-redux-app-4ed99",
  storageBucket: "react-redux-app-4ed99.appspot.com",
  messagingSenderId: "734287441099"
};

firebase.initializeApp(config);
firebase.firestore().settings({});

export default firebase